module.exports = __webpack_public_path__ + "static/img/geometry7.a2ed0af2.jpg";